import React from "react";
import workimage from "./assets/website.svg";
import Fade from "react-reveal/Fade";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Typed from "react-typed";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/css/bootstrap.css";
import "./App.css";
const Main3 = () => {
  const theme = useTheme();

  const isMd = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true,
  });
  return (
    <section className="about overflow-hidden py-5">
      <div className="w-100">
        <div className="row col-md-11 mx-auto ">
          <div className="col-md-6 ps-2">
            <Fade duration={4000} right className="about">
              <Grid
                item
                xs={12}
                md={6}
                alignItems={"left"}
                sx={{
                  width: "100%",
                }}
              >
                <Box
                  data-aos={isMd ? "fade-right" : "fade-up"}
                  paddingLeft={isMd && 2}
                  p={1}
                >
                  <Box marginBottom={2}>
                    <Typography
                      variant="h4"
                      color="text.primary"
                      sx={{
                        display: "grid",
                        color: "#fff",
                        fontSize: "1.90rem",
                        margin: "auto",
                        fontFamily: "Raleway",
                      }}
                    >
                      Designed, Developed and Deployed the websites naming
                      <Typography
                        color="#46c5fb"
                        component={"span"}
                        variant={"inherit"}
                      >
                        <Typed
                          strings={[
                            "eosworld.in",
                            "kyrosimpex.com",
                            "bharatbiofuels.com",
                          ]}
                          typeSpeed={100}
                          style={{ fontWeight: "600" }}
                          loop={true}
                        />
                      </Typography>
                    </Typography>
                  </Box>
                  <Box marginBottom={3}>
                    <Typography
                      variant="h6"
                      component="ul"
                      color="#fff"
                      style={{
                        fontFamily: "Arizona",
                        textAlign: "left",
                        fontSize: "1.1rem",
                        fontWeight: "400",
                      }}
                    >
                      <li>
                        Created user‑friendly interfaces, website responsiveness
                        and conducted thorough testing and debugging to ensure
                        for optimal user experience.
                      </li>
                      <li>The sites have an average response time of 2s.</li>
                      <li>
                        Developed using React‑JS, Material-UI, Bootstrap, HTML,
                        CSS.
                      </li>
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Fade>
          </div>
          <div className="col-md-6 img">
            <Fade duration={4000} left>
              <img src={`${workimage}`} alt="" className="img-fluid" />
            </Fade>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Main3;
